// Generated from E:/Code/identitydirector/src/app/shared/xpath-parser/xpath.g4 by ANTLR 4.13.2
// jshint ignore: start
import antlr4 from '../../utils/interop/antlr4';
import { xpathVisitor } from './xpathVisitor';

const serializedATN = [
  4, 1, 36, 203, 2, 0, 7, 0, 2, 1, 7, 1, 2, 2, 7, 2, 2, 3, 7, 3, 2, 4, 7, 4, 2, 5, 7, 5, 2, 6, 7, 6,
  2, 7, 7, 7, 2, 8, 7, 8, 2, 9, 7, 9, 2, 10, 7, 10, 2, 11, 7, 11, 2, 12, 7, 12, 2, 13, 7, 13, 2, 14,
  7, 14, 2, 15, 7, 15, 2, 16, 7, 16, 2, 17, 7, 17, 2, 18, 7, 18, 2, 19, 7, 19, 2, 20, 7, 20, 2, 21,
  7, 21, 2, 22, 7, 22, 2, 23, 7, 23, 2, 24, 7, 24, 2, 25, 7, 25, 1, 0, 1, 0, 1, 0, 1, 1, 1, 1, 1, 1,
  3, 1, 59, 8, 1, 1, 1, 1, 1, 1, 1, 5, 1, 64, 8, 1, 10, 1, 12, 1, 67, 9, 1, 1, 2, 1, 2, 1, 2, 1, 2,
  1, 2, 3, 2, 74, 8, 2, 1, 3, 1, 3, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 1, 4, 3, 4, 84, 8, 4, 1, 5, 1, 5,
  1, 6, 1, 6, 1, 6, 1, 6, 1, 7, 1, 7, 1, 7, 3, 7, 95, 8, 7, 1, 8, 1, 8, 1, 8, 1, 8, 1, 9, 1, 9, 1,
  10, 1, 10, 1, 10, 1, 10, 1, 10, 3, 10, 108, 8, 10, 1, 11, 1, 11, 1, 12, 1, 12, 1, 12, 1, 12, 1,
  13, 1, 13, 1, 14, 1, 14, 1, 14, 1, 14, 3, 14, 122, 8, 14, 1, 15, 1, 15, 1, 15, 1, 15, 1, 15, 1,
  15, 1, 15, 1, 15, 1, 15, 1, 15, 1, 15, 1, 15, 1, 15, 1, 15, 1, 15, 1, 15, 3, 15, 140, 8, 15, 1,
  15, 1, 15, 1, 15, 1, 15, 5, 15, 146, 8, 15, 10, 15, 12, 15, 149, 9, 15, 1, 16, 1, 16, 1, 16, 1,
  16, 1, 16, 1, 16, 1, 16, 3, 16, 158, 8, 16, 1, 17, 1, 17, 1, 18, 1, 18, 1, 18, 1, 18, 1, 18, 1,
  18, 1, 18, 1, 18, 1, 18, 3, 18, 171, 8, 18, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 1, 19, 5, 19, 179,
  8, 19, 10, 19, 12, 19, 182, 9, 19, 1, 20, 1, 20, 1, 20, 1, 20, 1, 20, 1, 20, 1, 20, 3, 20, 191, 8,
  20, 1, 21, 1, 21, 1, 22, 1, 22, 1, 23, 1, 23, 1, 24, 1, 24, 1, 25, 1, 25, 1, 25, 0, 3, 2, 30, 38,
  26, 0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48,
  50, 0, 6, 1, 0, 5, 6, 1, 0, 7, 12, 1, 0, 13, 20, 1, 0, 23, 24, 3, 0, 28, 28, 30, 30, 32, 32, 2, 0,
  26, 26, 34, 34, 205, 0, 52, 1, 0, 0, 0, 2, 58, 1, 0, 0, 0, 4, 73, 1, 0, 0, 0, 6, 75, 1, 0, 0, 0,
  8, 83, 1, 0, 0, 0, 10, 85, 1, 0, 0, 0, 12, 87, 1, 0, 0, 0, 14, 94, 1, 0, 0, 0, 16, 96, 1, 0, 0, 0,
  18, 100, 1, 0, 0, 0, 20, 107, 1, 0, 0, 0, 22, 109, 1, 0, 0, 0, 24, 111, 1, 0, 0, 0, 26, 115, 1, 0,
  0, 0, 28, 121, 1, 0, 0, 0, 30, 139, 1, 0, 0, 0, 32, 157, 1, 0, 0, 0, 34, 159, 1, 0, 0, 0, 36, 170,
  1, 0, 0, 0, 38, 172, 1, 0, 0, 0, 40, 190, 1, 0, 0, 0, 42, 192, 1, 0, 0, 0, 44, 194, 1, 0, 0, 0,
  46, 196, 1, 0, 0, 0, 48, 198, 1, 0, 0, 0, 50, 200, 1, 0, 0, 0, 52, 53, 3, 8, 4, 0, 53, 54, 5, 0,
  0, 1, 54, 1, 1, 0, 0, 0, 55, 56, 6, 1, -1, 0, 56, 59, 3, 4, 2, 0, 57, 59, 3, 36, 18, 0, 58, 55, 1,
  0, 0, 0, 58, 57, 1, 0, 0, 0, 59, 65, 1, 0, 0, 0, 60, 61, 10, 1, 0, 0, 61, 62, 5, 1, 0, 0, 62, 64,
  3, 2, 1, 2, 63, 60, 1, 0, 0, 0, 64, 67, 1, 0, 0, 0, 65, 63, 1, 0, 0, 0, 65, 66, 1, 0, 0, 0, 66, 3,
  1, 0, 0, 0, 67, 65, 1, 0, 0, 0, 68, 69, 3, 6, 3, 0, 69, 70, 3, 6, 3, 0, 70, 74, 1, 0, 0, 0, 71,
  74, 3, 36, 18, 0, 72, 74, 3, 8, 4, 0, 73, 68, 1, 0, 0, 0, 73, 71, 1, 0, 0, 0, 73, 72, 1, 0, 0, 0,
  74, 5, 1, 0, 0, 0, 75, 76, 3, 8, 4, 0, 76, 7, 1, 0, 0, 0, 77, 78, 5, 2, 0, 0, 78, 84, 3, 44, 22,
  0, 79, 80, 5, 2, 0, 0, 80, 81, 3, 44, 22, 0, 81, 82, 3, 10, 5, 0, 82, 84, 1, 0, 0, 0, 83, 77, 1,
  0, 0, 0, 83, 79, 1, 0, 0, 0, 84, 9, 1, 0, 0, 0, 85, 86, 3, 12, 6, 0, 86, 11, 1, 0, 0, 0, 87, 88,
  5, 3, 0, 0, 88, 89, 3, 14, 7, 0, 89, 90, 5, 4, 0, 0, 90, 13, 1, 0, 0, 0, 91, 95, 3, 30, 15, 0, 92,
  95, 3, 16, 8, 0, 93, 95, 3, 24, 12, 0, 94, 91, 1, 0, 0, 0, 94, 92, 1, 0, 0, 0, 94, 93, 1, 0, 0, 0,
  95, 15, 1, 0, 0, 0, 96, 97, 3, 46, 23, 0, 97, 98, 3, 18, 9, 0, 98, 99, 3, 20, 10, 0, 99, 17, 1, 0,
  0, 0, 100, 101, 7, 0, 0, 0, 101, 19, 1, 0, 0, 0, 102, 108, 3, 4, 2, 0, 103, 108, 3, 36, 18, 0,
  104, 108, 3, 22, 11, 0, 105, 108, 3, 48, 24, 0, 106, 108, 3, 50, 25, 0, 107, 102, 1, 0, 0, 0, 107,
  103, 1, 0, 0, 0, 107, 104, 1, 0, 0, 0, 107, 105, 1, 0, 0, 0, 107, 106, 1, 0, 0, 0, 108, 21, 1, 0,
  0, 0, 109, 110, 7, 1, 0, 0, 110, 23, 1, 0, 0, 0, 111, 112, 3, 46, 23, 0, 112, 113, 3, 26, 13, 0,
  113, 114, 3, 28, 14, 0, 114, 25, 1, 0, 0, 0, 115, 116, 7, 2, 0, 0, 116, 27, 1, 0, 0, 0, 117, 122,
  3, 36, 18, 0, 118, 122, 3, 4, 2, 0, 119, 122, 3, 48, 24, 0, 120, 122, 3, 50, 25, 0, 121, 117, 1,
  0, 0, 0, 121, 118, 1, 0, 0, 0, 121, 119, 1, 0, 0, 0, 121, 120, 1, 0, 0, 0, 122, 29, 1, 0, 0, 0,
  123, 124, 6, 15, -1, 0, 124, 140, 3, 32, 16, 0, 125, 126, 3, 32, 16, 0, 126, 127, 3, 34, 17, 0,
  127, 128, 3, 32, 16, 0, 128, 140, 1, 0, 0, 0, 129, 130, 5, 21, 0, 0, 130, 131, 3, 30, 15, 0, 131,
  132, 5, 22, 0, 0, 132, 133, 3, 34, 17, 0, 133, 134, 3, 32, 16, 0, 134, 140, 1, 0, 0, 0, 135, 136,
  5, 21, 0, 0, 136, 137, 3, 30, 15, 0, 137, 138, 5, 22, 0, 0, 138, 140, 1, 0, 0, 0, 139, 123, 1, 0,
  0, 0, 139, 125, 1, 0, 0, 0, 139, 129, 1, 0, 0, 0, 139, 135, 1, 0, 0, 0, 140, 147, 1, 0, 0, 0, 141,
  142, 10, 3, 0, 0, 142, 143, 3, 34, 17, 0, 143, 144, 3, 32, 16, 0, 144, 146, 1, 0, 0, 0, 145, 141,
  1, 0, 0, 0, 146, 149, 1, 0, 0, 0, 147, 145, 1, 0, 0, 0, 147, 148, 1, 0, 0, 0, 148, 31, 1, 0, 0, 0,
  149, 147, 1, 0, 0, 0, 150, 158, 3, 4, 2, 0, 151, 158, 3, 16, 8, 0, 152, 158, 3, 24, 12, 0, 153,
  154, 5, 21, 0, 0, 154, 155, 3, 30, 15, 0, 155, 156, 5, 22, 0, 0, 156, 158, 1, 0, 0, 0, 157, 150,
  1, 0, 0, 0, 157, 151, 1, 0, 0, 0, 157, 152, 1, 0, 0, 0, 157, 153, 1, 0, 0, 0, 158, 33, 1, 0, 0, 0,
  159, 160, 7, 3, 0, 0, 160, 35, 1, 0, 0, 0, 161, 162, 3, 42, 21, 0, 162, 163, 5, 21, 0, 0, 163,
  164, 3, 38, 19, 0, 164, 165, 5, 22, 0, 0, 165, 171, 1, 0, 0, 0, 166, 167, 3, 42, 21, 0, 167, 168,
  5, 21, 0, 0, 168, 169, 5, 22, 0, 0, 169, 171, 1, 0, 0, 0, 170, 161, 1, 0, 0, 0, 170, 166, 1, 0, 0,
  0, 171, 37, 1, 0, 0, 0, 172, 173, 6, 19, -1, 0, 173, 174, 3, 40, 20, 0, 174, 180, 1, 0, 0, 0, 175,
  176, 10, 1, 0, 0, 176, 177, 5, 25, 0, 0, 177, 179, 3, 40, 20, 0, 178, 175, 1, 0, 0, 0, 179, 182,
  1, 0, 0, 0, 180, 178, 1, 0, 0, 0, 180, 181, 1, 0, 0, 0, 181, 39, 1, 0, 0, 0, 182, 180, 1, 0, 0, 0,
  183, 191, 3, 46, 23, 0, 184, 191, 3, 4, 2, 0, 185, 191, 3, 16, 8, 0, 186, 191, 3, 30, 15, 0, 187,
  191, 3, 36, 18, 0, 188, 191, 3, 48, 24, 0, 189, 191, 3, 50, 25, 0, 190, 183, 1, 0, 0, 0, 190, 184,
  1, 0, 0, 0, 190, 185, 1, 0, 0, 0, 190, 186, 1, 0, 0, 0, 190, 187, 1, 0, 0, 0, 190, 188, 1, 0, 0,
  0, 190, 189, 1, 0, 0, 0, 191, 41, 1, 0, 0, 0, 192, 193, 7, 4, 0, 0, 193, 43, 1, 0, 0, 0, 194, 195,
  7, 5, 0, 0, 195, 45, 1, 0, 0, 0, 196, 197, 5, 34, 0, 0, 197, 47, 1, 0, 0, 0, 198, 199, 5, 35, 0,
  0, 199, 49, 1, 0, 0, 0, 200, 201, 5, 36, 0, 0, 201, 51, 1, 0, 0, 0, 13, 58, 65, 73, 83, 94, 107,
  121, 139, 147, 157, 170, 180, 190,
];

const atn = new antlr4.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map((ds, index) => new antlr4.DFA(ds, index));

const sharedContextCache = new antlr4.PredictionContextCache();

export default class xpathParser extends antlr4.Parser {
  static grammarFileName = 'xpath.g4';
  static literalNames = [
    null,
    "'|'",
    "'/'",
    "'['",
    "']'",
    "'='",
    "'!='",
    "'true'",
    "'false'",
    "'True'",
    "'False'",
    "'TRUE'",
    "'FALSE'",
    "'<='",
    "'<'",
    "'>='",
    "'>'",
    "'&lt;='",
    "'&lt;'",
    "'&gt;='",
    "'&gt;'",
    "'('",
    "')'",
    "'and'",
    "'or'",
    "','",
    "'*'",
  ];
  static symbolicNames = [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    'WS',
    'FnFunction',
    'FnFunctionName',
    'OpFunction',
    'OpFunctionName',
    'XsFunction',
    'XsFunctionName',
    'QNAME',
    'NUMBER',
    'STRING',
  ];
  static ruleNames = [
    'start',
    'expression',
    'locationPathExpression',
    'locationStep',
    'elementNodeLocationStep',
    'predicateList',
    'predicate',
    'predicateExpression',
    'equalityExpression',
    'equalityOperator',
    'rightEqualityTerm',
    'booleanToken',
    'relationalExpression',
    'relationalOperator',
    'rightRelationalTerm',
    'booleanExpression',
    'booleanTerm',
    'booleanOperator',
    'functionCallExpression',
    'parameterList',
    'parameter',
    'functionName',
    'objectType',
    'attribute',
    'number',
    'string',
  ];

  constructor(input) {
    super(input);
    this._interp = new antlr4.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
    this.ruleNames = xpathParser.ruleNames;
    this.literalNames = xpathParser.literalNames;
    this.symbolicNames = xpathParser.symbolicNames;
  }

  sempred(localctx, ruleIndex, predIndex) {
    switch (ruleIndex) {
      case 1:
        return this.expression_sempred(localctx, predIndex);
      case 15:
        return this.booleanExpression_sempred(localctx, predIndex);
      case 19:
        return this.parameterList_sempred(localctx, predIndex);
      default:
        throw 'No predicate with index:' + ruleIndex;
    }
  }

  expression_sempred(localctx, predIndex) {
    switch (predIndex) {
      case 0:
        return this.precpred(this._ctx, 1);
      default:
        throw 'No predicate with index:' + predIndex;
    }
  }

  booleanExpression_sempred(localctx, predIndex) {
    switch (predIndex) {
      case 1:
        return this.precpred(this._ctx, 3);
      default:
        throw 'No predicate with index:' + predIndex;
    }
  }

  parameterList_sempred(localctx, predIndex) {
    switch (predIndex) {
      case 2:
        return this.precpred(this._ctx, 1);
      default:
        throw 'No predicate with index:' + predIndex;
    }
  }

  start() {
    let localctx = new StartContext(this, this._ctx, this.state);
    this.enterRule(localctx, 0, xpathParser.RULE_start);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 52;
      this.elementNodeLocationStep();
      this.state = 53;
      this.match(xpathParser.EOF);
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  expression(_p) {
    if (_p === undefined) {
      _p = 0;
    }
    const _parentctx = this._ctx;
    const _parentState = this.state;
    let localctx = new ExpressionContext(this, this._ctx, _parentState);
    let _prevctx = localctx;
    const _startState = 2;
    this.enterRecursionRule(localctx, 2, xpathParser.RULE_expression, _p);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 58;
      this._errHandler.sync(this);
      var la_ = this._interp.adaptivePredict(this._input, 0, this._ctx);
      switch (la_) {
        case 1:
          this.state = 56;
          this.locationPathExpression();
          break;

        case 2:
          this.state = 57;
          this.functionCallExpression();
          break;
      }
      this._ctx.stop = this._input.LT(-1);
      this.state = 65;
      this._errHandler.sync(this);
      var _alt = this._interp.adaptivePredict(this._input, 1, this._ctx);
      while (_alt != 2 && _alt != antlr4.ATN.INVALID_ALT_NUMBER) {
        if (_alt === 1) {
          if (this._parseListeners !== null) {
            this.triggerExitRuleEvent();
          }
          _prevctx = localctx;
          localctx = new ExpressionContext(this, _parentctx, _parentState);
          this.pushNewRecursionContext(localctx, _startState, xpathParser.RULE_expression);
          this.state = 60;
          if (!this.precpred(this._ctx, 1)) {
            throw new antlr4.FailedPredicateException(this, 'this.precpred(this._ctx, 1)');
          }
          this.state = 61;
          this.match(xpathParser.T__0);
          this.state = 62;
          this.expression(2);
        }
        this.state = 67;
        this._errHandler.sync(this);
        _alt = this._interp.adaptivePredict(this._input, 1, this._ctx);
      }
    } catch (error) {
      if (error instanceof antlr4.RecognitionException) {
        localctx.exception = error;
        this._errHandler.reportError(this, error);
        this._errHandler.recover(this, error);
      } else {
        throw error;
      }
    } finally {
      this.unrollRecursionContexts(_parentctx);
    }
    return localctx;
  }

  locationPathExpression() {
    let localctx = new LocationPathExpressionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 4, xpathParser.RULE_locationPathExpression);
    try {
      this.state = 73;
      this._errHandler.sync(this);
      var la_ = this._interp.adaptivePredict(this._input, 2, this._ctx);
      switch (la_) {
        case 1:
          this.enterOuterAlt(localctx, 1);
          this.state = 68;
          this.locationStep();
          this.state = 69;
          this.locationStep();
          break;

        case 2:
          this.enterOuterAlt(localctx, 2);
          this.state = 71;
          this.functionCallExpression();
          break;

        case 3:
          this.enterOuterAlt(localctx, 3);
          this.state = 72;
          this.elementNodeLocationStep();
          break;
      }
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  locationStep() {
    let localctx = new LocationStepContext(this, this._ctx, this.state);
    this.enterRule(localctx, 6, xpathParser.RULE_locationStep);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 75;
      this.elementNodeLocationStep();
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  elementNodeLocationStep() {
    let localctx = new ElementNodeLocationStepContext(this, this._ctx, this.state);
    this.enterRule(localctx, 8, xpathParser.RULE_elementNodeLocationStep);
    try {
      this.state = 83;
      this._errHandler.sync(this);
      var la_ = this._interp.adaptivePredict(this._input, 3, this._ctx);
      switch (la_) {
        case 1:
          this.enterOuterAlt(localctx, 1);
          this.state = 77;
          this.match(xpathParser.T__1);
          this.state = 78;
          this.objectType();
          break;

        case 2:
          this.enterOuterAlt(localctx, 2);
          this.state = 79;
          this.match(xpathParser.T__1);
          this.state = 80;
          this.objectType();
          this.state = 81;
          this.predicateList();
          break;
      }
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  predicateList() {
    let localctx = new PredicateListContext(this, this._ctx, this.state);
    this.enterRule(localctx, 10, xpathParser.RULE_predicateList);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 85;
      this.predicate();
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  predicate() {
    let localctx = new PredicateContext(this, this._ctx, this.state);
    this.enterRule(localctx, 12, xpathParser.RULE_predicate);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 87;
      this.match(xpathParser.T__2);
      this.state = 88;
      this.predicateExpression();
      this.state = 89;
      this.match(xpathParser.T__3);
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  predicateExpression() {
    let localctx = new PredicateExpressionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 14, xpathParser.RULE_predicateExpression);
    try {
      this.state = 94;
      this._errHandler.sync(this);
      var la_ = this._interp.adaptivePredict(this._input, 4, this._ctx);
      switch (la_) {
        case 1:
          this.enterOuterAlt(localctx, 1);
          this.state = 91;
          this.booleanExpression(0);
          break;

        case 2:
          this.enterOuterAlt(localctx, 2);
          this.state = 92;
          this.equalityExpression();
          break;

        case 3:
          this.enterOuterAlt(localctx, 3);
          this.state = 93;
          this.relationalExpression();
          break;
      }
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  equalityExpression() {
    let localctx = new EqualityExpressionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 16, xpathParser.RULE_equalityExpression);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 96;
      this.attribute();
      this.state = 97;
      this.equalityOperator();
      this.state = 98;
      this.rightEqualityTerm();
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  equalityOperator() {
    let localctx = new EqualityOperatorContext(this, this._ctx, this.state);
    this.enterRule(localctx, 18, xpathParser.RULE_equalityOperator);
    var _la = 0;
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 100;
      _la = this._input.LA(1);
      if (!(_la === 5 || _la === 6)) {
        this._errHandler.recoverInline(this);
      } else {
        this._errHandler.reportMatch(this);
        this.consume();
      }
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  rightEqualityTerm() {
    let localctx = new RightEqualityTermContext(this, this._ctx, this.state);
    this.enterRule(localctx, 20, xpathParser.RULE_rightEqualityTerm);
    try {
      this.state = 107;
      this._errHandler.sync(this);
      var la_ = this._interp.adaptivePredict(this._input, 5, this._ctx);
      switch (la_) {
        case 1:
          this.enterOuterAlt(localctx, 1);
          this.state = 102;
          this.locationPathExpression();
          break;

        case 2:
          this.enterOuterAlt(localctx, 2);
          this.state = 103;
          this.functionCallExpression();
          break;

        case 3:
          this.enterOuterAlt(localctx, 3);
          this.state = 104;
          this.booleanToken();
          break;

        case 4:
          this.enterOuterAlt(localctx, 4);
          this.state = 105;
          this.number();
          break;

        case 5:
          this.enterOuterAlt(localctx, 5);
          this.state = 106;
          this.string();
          break;
      }
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  booleanToken() {
    let localctx = new BooleanTokenContext(this, this._ctx, this.state);
    this.enterRule(localctx, 22, xpathParser.RULE_booleanToken);
    var _la = 0;
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 109;
      _la = this._input.LA(1);
      if (!((_la & ~0x1f) === 0 && ((1 << _la) & 8064) !== 0)) {
        this._errHandler.recoverInline(this);
      } else {
        this._errHandler.reportMatch(this);
        this.consume();
      }
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  relationalExpression() {
    let localctx = new RelationalExpressionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 24, xpathParser.RULE_relationalExpression);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 111;
      this.attribute();
      this.state = 112;
      this.relationalOperator();
      this.state = 113;
      this.rightRelationalTerm();
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  relationalOperator() {
    let localctx = new RelationalOperatorContext(this, this._ctx, this.state);
    this.enterRule(localctx, 26, xpathParser.RULE_relationalOperator);
    var _la = 0;
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 115;
      _la = this._input.LA(1);
      if (!((_la & ~0x1f) === 0 && ((1 << _la) & 2088960) !== 0)) {
        this._errHandler.recoverInline(this);
      } else {
        this._errHandler.reportMatch(this);
        this.consume();
      }
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  rightRelationalTerm() {
    let localctx = new RightRelationalTermContext(this, this._ctx, this.state);
    this.enterRule(localctx, 28, xpathParser.RULE_rightRelationalTerm);
    try {
      this.state = 121;
      this._errHandler.sync(this);
      var la_ = this._interp.adaptivePredict(this._input, 6, this._ctx);
      switch (la_) {
        case 1:
          this.enterOuterAlt(localctx, 1);
          this.state = 117;
          this.functionCallExpression();
          break;

        case 2:
          this.enterOuterAlt(localctx, 2);
          this.state = 118;
          this.locationPathExpression();
          break;

        case 3:
          this.enterOuterAlt(localctx, 3);
          this.state = 119;
          this.number();
          break;

        case 4:
          this.enterOuterAlt(localctx, 4);
          this.state = 120;
          this.string();
          break;
      }
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  booleanExpression(_p) {
    if (_p === undefined) {
      _p = 0;
    }
    const _parentctx = this._ctx;
    const _parentState = this.state;
    let localctx = new BooleanExpressionContext(this, this._ctx, _parentState);
    let _prevctx = localctx;
    const _startState = 30;
    this.enterRecursionRule(localctx, 30, xpathParser.RULE_booleanExpression, _p);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 139;
      this._errHandler.sync(this);
      var la_ = this._interp.adaptivePredict(this._input, 7, this._ctx);
      switch (la_) {
        case 1:
          this.state = 124;
          this.booleanTerm();
          break;

        case 2:
          this.state = 125;
          this.booleanTerm();
          this.state = 126;
          this.booleanOperator();
          this.state = 127;
          this.booleanTerm();
          break;

        case 3:
          this.state = 129;
          this.match(xpathParser.T__20);
          this.state = 130;
          this.booleanExpression(0);
          this.state = 131;
          this.match(xpathParser.T__21);
          this.state = 132;
          this.booleanOperator();
          this.state = 133;
          this.booleanTerm();
          break;

        case 4:
          this.state = 135;
          this.match(xpathParser.T__20);
          this.state = 136;
          this.booleanExpression(0);
          this.state = 137;
          this.match(xpathParser.T__21);
          break;
      }
      this._ctx.stop = this._input.LT(-1);
      this.state = 147;
      this._errHandler.sync(this);
      var _alt = this._interp.adaptivePredict(this._input, 8, this._ctx);
      while (_alt != 2 && _alt != antlr4.ATN.INVALID_ALT_NUMBER) {
        if (_alt === 1) {
          if (this._parseListeners !== null) {
            this.triggerExitRuleEvent();
          }
          _prevctx = localctx;
          localctx = new BooleanExpressionContext(this, _parentctx, _parentState);
          this.pushNewRecursionContext(localctx, _startState, xpathParser.RULE_booleanExpression);
          this.state = 141;
          if (!this.precpred(this._ctx, 3)) {
            throw new antlr4.FailedPredicateException(this, 'this.precpred(this._ctx, 3)');
          }
          this.state = 142;
          this.booleanOperator();
          this.state = 143;
          this.booleanTerm();
        }
        this.state = 149;
        this._errHandler.sync(this);
        _alt = this._interp.adaptivePredict(this._input, 8, this._ctx);
      }
    } catch (error) {
      if (error instanceof antlr4.RecognitionException) {
        localctx.exception = error;
        this._errHandler.reportError(this, error);
        this._errHandler.recover(this, error);
      } else {
        throw error;
      }
    } finally {
      this.unrollRecursionContexts(_parentctx);
    }
    return localctx;
  }

  booleanTerm() {
    let localctx = new BooleanTermContext(this, this._ctx, this.state);
    this.enterRule(localctx, 32, xpathParser.RULE_booleanTerm);
    try {
      this.state = 157;
      this._errHandler.sync(this);
      var la_ = this._interp.adaptivePredict(this._input, 9, this._ctx);
      switch (la_) {
        case 1:
          this.enterOuterAlt(localctx, 1);
          this.state = 150;
          this.locationPathExpression();
          break;

        case 2:
          this.enterOuterAlt(localctx, 2);
          this.state = 151;
          this.equalityExpression();
          break;

        case 3:
          this.enterOuterAlt(localctx, 3);
          this.state = 152;
          this.relationalExpression();
          break;

        case 4:
          this.enterOuterAlt(localctx, 4);
          this.state = 153;
          this.match(xpathParser.T__20);
          this.state = 154;
          this.booleanExpression(0);
          this.state = 155;
          this.match(xpathParser.T__21);
          break;
      }
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  booleanOperator() {
    let localctx = new BooleanOperatorContext(this, this._ctx, this.state);
    this.enterRule(localctx, 34, xpathParser.RULE_booleanOperator);
    var _la = 0;
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 159;
      _la = this._input.LA(1);
      if (!(_la === 23 || _la === 24)) {
        this._errHandler.recoverInline(this);
      } else {
        this._errHandler.reportMatch(this);
        this.consume();
      }
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  functionCallExpression() {
    let localctx = new FunctionCallExpressionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 36, xpathParser.RULE_functionCallExpression);
    try {
      this.state = 170;
      this._errHandler.sync(this);
      var la_ = this._interp.adaptivePredict(this._input, 10, this._ctx);
      switch (la_) {
        case 1:
          this.enterOuterAlt(localctx, 1);
          this.state = 161;
          this.functionName();
          this.state = 162;
          this.match(xpathParser.T__20);
          this.state = 163;
          this.parameterList(0);
          this.state = 164;
          this.match(xpathParser.T__21);
          break;

        case 2:
          this.enterOuterAlt(localctx, 2);
          this.state = 166;
          this.functionName();
          this.state = 167;
          this.match(xpathParser.T__20);
          this.state = 168;
          this.match(xpathParser.T__21);
          break;
      }
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  parameterList(_p) {
    if (_p === undefined) {
      _p = 0;
    }
    const _parentctx = this._ctx;
    const _parentState = this.state;
    let localctx = new ParameterListContext(this, this._ctx, _parentState);
    let _prevctx = localctx;
    const _startState = 38;
    this.enterRecursionRule(localctx, 38, xpathParser.RULE_parameterList, _p);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 173;
      this.parameter();
      this._ctx.stop = this._input.LT(-1);
      this.state = 180;
      this._errHandler.sync(this);
      var _alt = this._interp.adaptivePredict(this._input, 11, this._ctx);
      while (_alt != 2 && _alt != antlr4.ATN.INVALID_ALT_NUMBER) {
        if (_alt === 1) {
          if (this._parseListeners !== null) {
            this.triggerExitRuleEvent();
          }
          _prevctx = localctx;
          localctx = new ParameterListContext(this, _parentctx, _parentState);
          this.pushNewRecursionContext(localctx, _startState, xpathParser.RULE_parameterList);
          this.state = 175;
          if (!this.precpred(this._ctx, 1)) {
            throw new antlr4.FailedPredicateException(this, 'this.precpred(this._ctx, 1)');
          }
          this.state = 176;
          this.match(xpathParser.T__24);
          this.state = 177;
          this.parameter();
        }
        this.state = 182;
        this._errHandler.sync(this);
        _alt = this._interp.adaptivePredict(this._input, 11, this._ctx);
      }
    } catch (error) {
      if (error instanceof antlr4.RecognitionException) {
        localctx.exception = error;
        this._errHandler.reportError(this, error);
        this._errHandler.recover(this, error);
      } else {
        throw error;
      }
    } finally {
      this.unrollRecursionContexts(_parentctx);
    }
    return localctx;
  }

  parameter() {
    let localctx = new ParameterContext(this, this._ctx, this.state);
    this.enterRule(localctx, 40, xpathParser.RULE_parameter);
    try {
      this.state = 190;
      this._errHandler.sync(this);
      var la_ = this._interp.adaptivePredict(this._input, 12, this._ctx);
      switch (la_) {
        case 1:
          this.enterOuterAlt(localctx, 1);
          this.state = 183;
          this.attribute();
          break;

        case 2:
          this.enterOuterAlt(localctx, 2);
          this.state = 184;
          this.locationPathExpression();
          break;

        case 3:
          this.enterOuterAlt(localctx, 3);
          this.state = 185;
          this.equalityExpression();
          break;

        case 4:
          this.enterOuterAlt(localctx, 4);
          this.state = 186;
          this.booleanExpression(0);
          break;

        case 5:
          this.enterOuterAlt(localctx, 5);
          this.state = 187;
          this.functionCallExpression();
          break;

        case 6:
          this.enterOuterAlt(localctx, 6);
          this.state = 188;
          this.number();
          break;

        case 7:
          this.enterOuterAlt(localctx, 7);
          this.state = 189;
          this.string();
          break;
      }
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  functionName() {
    let localctx = new FunctionNameContext(this, this._ctx, this.state);
    this.enterRule(localctx, 42, xpathParser.RULE_functionName);
    var _la = 0;
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 192;
      _la = this._input.LA(1);
      if (!(((_la - 28) & ~0x1f) === 0 && ((1 << (_la - 28)) & 21) !== 0)) {
        this._errHandler.recoverInline(this);
      } else {
        this._errHandler.reportMatch(this);
        this.consume();
      }
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  objectType() {
    let localctx = new ObjectTypeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 44, xpathParser.RULE_objectType);
    var _la = 0;
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 194;
      _la = this._input.LA(1);
      if (!(_la === 26 || _la === 34)) {
        this._errHandler.recoverInline(this);
      } else {
        this._errHandler.reportMatch(this);
        this.consume();
      }
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  attribute() {
    let localctx = new AttributeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 46, xpathParser.RULE_attribute);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 196;
      this.match(xpathParser.QNAME);
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  number() {
    let localctx = new NumberContext(this, this._ctx, this.state);
    this.enterRule(localctx, 48, xpathParser.RULE_number);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 198;
      this.match(xpathParser.NUMBER);
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }

  string() {
    let localctx = new StringContext(this, this._ctx, this.state);
    this.enterRule(localctx, 50, xpathParser.RULE_string);
    try {
      this.enterOuterAlt(localctx, 1);
      this.state = 200;
      this.match(xpathParser.STRING);
    } catch (re) {
      if (re instanceof antlr4.RecognitionException) {
        localctx.exception = re;
        this._errHandler.reportError(this, re);
        this._errHandler.recover(this, re);
      } else {
        throw re;
      }
    } finally {
      this.exitRule();
    }
    return localctx;
  }
}

xpathParser.EOF = antlr4.Token.EOF;
xpathParser.T__0 = 1;
xpathParser.T__1 = 2;
xpathParser.T__2 = 3;
xpathParser.T__3 = 4;
xpathParser.T__4 = 5;
xpathParser.T__5 = 6;
xpathParser.T__6 = 7;
xpathParser.T__7 = 8;
xpathParser.T__8 = 9;
xpathParser.T__9 = 10;
xpathParser.T__10 = 11;
xpathParser.T__11 = 12;
xpathParser.T__12 = 13;
xpathParser.T__13 = 14;
xpathParser.T__14 = 15;
xpathParser.T__15 = 16;
xpathParser.T__16 = 17;
xpathParser.T__17 = 18;
xpathParser.T__18 = 19;
xpathParser.T__19 = 20;
xpathParser.T__20 = 21;
xpathParser.T__21 = 22;
xpathParser.T__22 = 23;
xpathParser.T__23 = 24;
xpathParser.T__24 = 25;
xpathParser.T__25 = 26;
xpathParser.WS = 27;
xpathParser.FnFunction = 28;
xpathParser.FnFunctionName = 29;
xpathParser.OpFunction = 30;
xpathParser.OpFunctionName = 31;
xpathParser.XsFunction = 32;
xpathParser.XsFunctionName = 33;
xpathParser.QNAME = 34;
xpathParser.NUMBER = 35;
xpathParser.STRING = 36;

xpathParser.RULE_start = 0;
xpathParser.RULE_expression = 1;
xpathParser.RULE_locationPathExpression = 2;
xpathParser.RULE_locationStep = 3;
xpathParser.RULE_elementNodeLocationStep = 4;
xpathParser.RULE_predicateList = 5;
xpathParser.RULE_predicate = 6;
xpathParser.RULE_predicateExpression = 7;
xpathParser.RULE_equalityExpression = 8;
xpathParser.RULE_equalityOperator = 9;
xpathParser.RULE_rightEqualityTerm = 10;
xpathParser.RULE_booleanToken = 11;
xpathParser.RULE_relationalExpression = 12;
xpathParser.RULE_relationalOperator = 13;
xpathParser.RULE_rightRelationalTerm = 14;
xpathParser.RULE_booleanExpression = 15;
xpathParser.RULE_booleanTerm = 16;
xpathParser.RULE_booleanOperator = 17;
xpathParser.RULE_functionCallExpression = 18;
xpathParser.RULE_parameterList = 19;
xpathParser.RULE_parameter = 20;
xpathParser.RULE_functionName = 21;
xpathParser.RULE_objectType = 22;
xpathParser.RULE_attribute = 23;
xpathParser.RULE_number = 24;
xpathParser.RULE_string = 25;

class StartContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_start;
  }

  elementNodeLocationStep() {
    return this.getTypedRuleContext(ElementNodeLocationStepContext, 0);
  }

  EOF() {
    return this.getToken(xpathParser.EOF, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterStart(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitStart(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitStart(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class ExpressionContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_expression;
  }

  locationPathExpression() {
    return this.getTypedRuleContext(LocationPathExpressionContext, 0);
  }

  functionCallExpression() {
    return this.getTypedRuleContext(FunctionCallExpressionContext, 0);
  }

  expression = function (i) {
    if (i === undefined) {
      i = null;
    }
    if (i === null) {
      return this.getTypedRuleContexts(ExpressionContext);
    } else {
      return this.getTypedRuleContext(ExpressionContext, i);
    }
  };

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterExpression(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitExpression(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class LocationPathExpressionContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_locationPathExpression;
  }

  locationStep = function (i) {
    if (i === undefined) {
      i = null;
    }
    if (i === null) {
      return this.getTypedRuleContexts(LocationStepContext);
    } else {
      return this.getTypedRuleContext(LocationStepContext, i);
    }
  };

  functionCallExpression() {
    return this.getTypedRuleContext(FunctionCallExpressionContext, 0);
  }

  elementNodeLocationStep() {
    return this.getTypedRuleContext(ElementNodeLocationStepContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterLocationPathExpression(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitLocationPathExpression(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitLocationPathExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class LocationStepContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_locationStep;
  }

  elementNodeLocationStep() {
    return this.getTypedRuleContext(ElementNodeLocationStepContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterLocationStep(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitLocationStep(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitLocationStep(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class ElementNodeLocationStepContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_elementNodeLocationStep;
  }

  objectType() {
    return this.getTypedRuleContext(ObjectTypeContext, 0);
  }

  predicateList() {
    return this.getTypedRuleContext(PredicateListContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterElementNodeLocationStep(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitElementNodeLocationStep(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitElementNodeLocationStep(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class PredicateListContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_predicateList;
  }

  predicate() {
    return this.getTypedRuleContext(PredicateContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterPredicateList(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitPredicateList(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitPredicateList(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class PredicateContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_predicate;
  }

  predicateExpression() {
    return this.getTypedRuleContext(PredicateExpressionContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterPredicate(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitPredicate(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitPredicate(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class PredicateExpressionContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_predicateExpression;
  }

  booleanExpression() {
    return this.getTypedRuleContext(BooleanExpressionContext, 0);
  }

  equalityExpression() {
    return this.getTypedRuleContext(EqualityExpressionContext, 0);
  }

  relationalExpression() {
    return this.getTypedRuleContext(RelationalExpressionContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterPredicateExpression(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitPredicateExpression(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitPredicateExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class EqualityExpressionContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_equalityExpression;
  }

  attribute() {
    return this.getTypedRuleContext(AttributeContext, 0);
  }

  equalityOperator() {
    return this.getTypedRuleContext(EqualityOperatorContext, 0);
  }

  rightEqualityTerm() {
    return this.getTypedRuleContext(RightEqualityTermContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterEqualityExpression(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitEqualityExpression(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitEqualityExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class EqualityOperatorContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_equalityOperator;
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitEqualityOperator(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class RightEqualityTermContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_rightEqualityTerm;
  }

  locationPathExpression() {
    return this.getTypedRuleContext(LocationPathExpressionContext, 0);
  }

  functionCallExpression() {
    return this.getTypedRuleContext(FunctionCallExpressionContext, 0);
  }

  booleanToken() {
    return this.getTypedRuleContext(BooleanTokenContext, 0);
  }

  number() {
    return this.getTypedRuleContext(NumberContext, 0);
  }

  string() {
    return this.getTypedRuleContext(StringContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterRightEqualityTerm(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitRightEqualityTerm(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitRightEqualityTerm(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class BooleanTokenContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_booleanToken;
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterBooleanToken(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitBooleanToken(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitBooleanToken(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class RelationalExpressionContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_relationalExpression;
  }

  attribute() {
    return this.getTypedRuleContext(AttributeContext, 0);
  }

  relationalOperator() {
    return this.getTypedRuleContext(RelationalOperatorContext, 0);
  }

  rightRelationalTerm() {
    return this.getTypedRuleContext(RightRelationalTermContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterRelationalExpression(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitRelationalExpression(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitRelationalExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class RelationalOperatorContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_relationalOperator;
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterRelationalOperator(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitRelationalOperator(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitRelationalOperator(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class RightRelationalTermContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_rightRelationalTerm;
  }

  functionCallExpression() {
    return this.getTypedRuleContext(FunctionCallExpressionContext, 0);
  }

  locationPathExpression() {
    return this.getTypedRuleContext(LocationPathExpressionContext, 0);
  }

  number() {
    return this.getTypedRuleContext(NumberContext, 0);
  }

  string() {
    return this.getTypedRuleContext(StringContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterRightRelationalTerm(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitRightRelationalTerm(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitRightRelationalTerm(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class BooleanExpressionContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_booleanExpression;
  }

  booleanTerm = function (i) {
    if (i === undefined) {
      i = null;
    }
    if (i === null) {
      return this.getTypedRuleContexts(BooleanTermContext);
    } else {
      return this.getTypedRuleContext(BooleanTermContext, i);
    }
  };

  booleanOperator() {
    return this.getTypedRuleContext(BooleanOperatorContext, 0);
  }

  booleanExpression() {
    return this.getTypedRuleContext(BooleanExpressionContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterBooleanExpression(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitBooleanExpression(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitBooleanExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class BooleanTermContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_booleanTerm;
  }

  locationPathExpression() {
    return this.getTypedRuleContext(LocationPathExpressionContext, 0);
  }

  equalityExpression() {
    return this.getTypedRuleContext(EqualityExpressionContext, 0);
  }

  relationalExpression() {
    return this.getTypedRuleContext(RelationalExpressionContext, 0);
  }

  booleanExpression() {
    return this.getTypedRuleContext(BooleanExpressionContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterBooleanTerm(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitBooleanTerm(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitBooleanTerm(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class BooleanOperatorContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_booleanOperator;
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterBooleanOperator(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitBooleanOperator(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitBooleanOperator(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class FunctionCallExpressionContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_functionCallExpression;
  }

  functionName() {
    return this.getTypedRuleContext(FunctionNameContext, 0);
  }

  parameterList() {
    return this.getTypedRuleContext(ParameterListContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterFunctionCallExpression(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitFunctionCallExpression(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitFunctionCallExpression(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class ParameterListContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_parameterList;
  }

  parameter() {
    return this.getTypedRuleContext(ParameterContext, 0);
  }

  parameterList() {
    return this.getTypedRuleContext(ParameterListContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterParameterList(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitParameterList(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitParameterList(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class ParameterContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_parameter;
  }

  attribute() {
    return this.getTypedRuleContext(AttributeContext, 0);
  }

  locationPathExpression() {
    return this.getTypedRuleContext(LocationPathExpressionContext, 0);
  }

  equalityExpression() {
    return this.getTypedRuleContext(EqualityExpressionContext, 0);
  }

  booleanExpression() {
    return this.getTypedRuleContext(BooleanExpressionContext, 0);
  }

  functionCallExpression() {
    return this.getTypedRuleContext(FunctionCallExpressionContext, 0);
  }

  number() {
    return this.getTypedRuleContext(NumberContext, 0);
  }

  string() {
    return this.getTypedRuleContext(StringContext, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterParameter(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitParameter(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitParameter(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class FunctionNameContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_functionName;
  }

  FnFunction() {
    return this.getToken(xpathParser.FnFunction, 0);
  }

  OpFunction() {
    return this.getToken(xpathParser.OpFunction, 0);
  }

  XsFunction() {
    return this.getToken(xpathParser.XsFunction, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterFunctionName(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitFunctionName(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitFunctionName(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class ObjectTypeContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_objectType;
  }

  QNAME() {
    return this.getToken(xpathParser.QNAME, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterObjectType(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitObjectType(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitObjectType(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class AttributeContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_attribute;
  }

  QNAME() {
    return this.getToken(xpathParser.QNAME, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterAttribute(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitAttribute(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitAttribute(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class NumberContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_number;
  }

  NUMBER() {
    return this.getToken(xpathParser.NUMBER, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterNumber(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitNumber(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitNumber(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

class StringContext extends antlr4.ParserRuleContext {
  constructor(parser, parent, invokingState) {
    if (parent === undefined) {
      parent = null;
    }
    if (invokingState === undefined || invokingState === null) {
      invokingState = -1;
    }
    super(parent, invokingState);
    this.parser = parser;
    this.ruleIndex = xpathParser.RULE_string;
  }

  STRING() {
    return this.getToken(xpathParser.STRING, 0);
  }

  enterRule(listener) {
    if (listener instanceof xpathListener) {
      listener.enterString(this);
    }
  }

  exitRule(listener) {
    if (listener instanceof xpathListener) {
      listener.exitString(this);
    }
  }

  accept(visitor) {
    if (visitor instanceof xpathVisitor) {
      return visitor.visitString(this);
    } else {
      return visitor.visitChildren(this);
    }
  }
}

xpathParser.StartContext = StartContext;
xpathParser.ExpressionContext = ExpressionContext;
xpathParser.LocationPathExpressionContext = LocationPathExpressionContext;
xpathParser.LocationStepContext = LocationStepContext;
xpathParser.ElementNodeLocationStepContext = ElementNodeLocationStepContext;
xpathParser.PredicateListContext = PredicateListContext;
xpathParser.PredicateContext = PredicateContext;
xpathParser.PredicateExpressionContext = PredicateExpressionContext;
xpathParser.EqualityExpressionContext = EqualityExpressionContext;
xpathParser.EqualityOperatorContext = EqualityOperatorContext;
xpathParser.RightEqualityTermContext = RightEqualityTermContext;
xpathParser.BooleanTokenContext = BooleanTokenContext;
xpathParser.RelationalExpressionContext = RelationalExpressionContext;
xpathParser.RelationalOperatorContext = RelationalOperatorContext;
xpathParser.RightRelationalTermContext = RightRelationalTermContext;
xpathParser.BooleanExpressionContext = BooleanExpressionContext;
xpathParser.BooleanTermContext = BooleanTermContext;
xpathParser.BooleanOperatorContext = BooleanOperatorContext;
xpathParser.FunctionCallExpressionContext = FunctionCallExpressionContext;
xpathParser.ParameterListContext = ParameterListContext;
xpathParser.ParameterContext = ParameterContext;
xpathParser.FunctionNameContext = FunctionNameContext;
xpathParser.ObjectTypeContext = ObjectTypeContext;
xpathParser.AttributeContext = AttributeContext;
xpathParser.NumberContext = NumberContext;
xpathParser.StringContext = StringContext;
